import { render, staticRenderFns } from "./nasatv_schedule.vue?vue&type=template&id=02ed9cfa&scoped=true&"
import script from "./nasatv_schedule.vue?vue&type=script&lang=ts&"
export * from "./nasatv_schedule.vue?vue&type=script&lang=ts&"
import style0 from "./nasatv_schedule.vue?vue&type=style&index=0&id=02ed9cfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ed9cfa",
  null
  
)

export default component.exports